<template>
    <table v-if="enabled && hasRows && !isEmpty" class="tabs-table">
        <thead>
            <tr>
                <th v-for="(heading, index) in tableData.thead" :key="index">{{ heading.value }}</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(row, index) in tableData.tbody" :key="index">
                <td v-for="(col, subindex) in row.body" :key="subindex">
                    {{ col.value }}
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script setup lang="ts">
import type { IL4AirportContent } from '~/types/components/L4Airport';

const { airportContent, enabled, type } = defineProps<{
    airportContent: IL4AirportContent;
    enabled: boolean;
    type: string;
}>();

const hasRows: ComputedRef<boolean> = computed(() => airportContent[type] && airportContent[type].tbody.length > 0);

const isEmpty: ComputedRef<boolean> = computed(() => {
    return !!airportContent[type]?.tbody?.every((x: any) => {
        return Object.values(x.body).every((row: any) => row.value === '');
    });
});

const tableData = computed(() => airportContent[type]);
</script>

<style lang="postcss" scoped>
.tabs-table {
    @apply border-collapse w-full;
    td,
    th {
        @apply p-2 text-left border-0 text-base leading-none;
    }
    th:not(:first-child),
    td:not(:first-child) {
        @apply text-center;
    }
    tr:nth-child(2n) {
        @apply bg-[#eee];
    }
}
</style>
